import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { t } from '@lingui/macro';

import FormSection from '../../form/FormSection';
import ListSelectorField from '../../form/ListSelectorField';
import { useDataService } from '../../../services/ApiDataService';
import {
    GROUPS_ADMIN_ALLOW_DRILL_IN_FIELD,
    GROUPS_ADMIN_DESCRIPTION_FIELD,
    GROUPS_ADMIN_NAME_FIELD,
} from '../groups/GroupsAdminConstants';
import { GROUPS_FIELD } from './UserConstants';
import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { useIsSysAdminUser } from '../../../stores/SessionStore';

const useStyles = makeStyles({
    selectorWrapper: {
        marginTop: 16,
    },
});

export const GROUPS_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: GROUPS_ADMIN_NAME_FIELD,
        title: t`Group Name`,
        width: 240,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'userCount',
        title: t`Members`,
        sortable: true,
        width: 120,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: GROUPS_ADMIN_ALLOW_DRILL_IN_FIELD,
        title: t`Can Drill In`,
        sortable: true,
        width: 160,
        formatter: (value) => (value ? t`Yes` : t`No`),
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: GROUPS_ADMIN_DESCRIPTION_FIELD,
        title: t`Description`,
        sortable: true,
        width: 700,
        maxWidth: 800,
    },
];

export function UserAdminGroupsSection({ formData, setGroupsSelectionIsDirty }) {
    const styles = useStyles();
    const [groups, setGroups] = useState([]);
    const dataService = useDataService();
    const [isSysAdmin] = useIsSysAdminUser();
    const canEditGroups = isSysAdmin && formData?.source !== 'default';

    useEffect(() => {
        (async () => {
            const groupData = await dataService.get('/ipm/v1/admin/groups');
            setGroups(groupData);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormSection title={t`User Assigned Groups`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={GROUPS_COLUMNS}
                    dataArray={groups}
                    dataArraySearchFields={['groupName', 'description']}
                    dbSelected={formData?.groups || ['00000000-0000-0000-0000-000000000000']}
                    fieldName={GROUPS_FIELD}
                    addButtonText={t`Assign User To Groups`}
                    removeButtonText={t`Remove`}
                    setSelectionIsDirty={setGroupsSelectionIsDirty}
                    selectedEmptyGridText={t`This users is not assigned to any groups.`}
                    disabled={!canEditGroups}
                    hideActions={!canEditGroups}
                />
            </div>
        </FormSection>
    );
}
